import { Component, Inject } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { TrpcAPIService } from '../../trpc-api.service';
import { inferRouterOutputs } from '@trpc/server';
import { AppRouter } from '@server/src';
import { Router } from '@angular/router';

type ArrayElement<ArrayType extends readonly unknown[]> =
  ArrayType extends readonly (infer ElementType)[] ? ElementType : never;

type RouterOutput = inferRouterOutputs<AppRouter>;
type DealerList = RouterOutput['klanten']['getRWDealers'];
type DealeInfo = ArrayElement<DealerList>;


type KopInfo = RouterOutput['klanten']['getKopInfo'];

@Component({
  selector: 'app-klatn-form',
  templateUrl: './klant-form.component.html',
  styleUrls: ['./klant-form.component.scss']
})
export class KlantFormComponent extends DialogContentBase {

  constructor(public dialog: DialogRef, @Inject('ServerApi')public apiService: TrpcAPIService, private router: Router) {
    super(dialog);
  }

  public dealers: DealerList = [];
  public filteredDealers: DealerList = [];
  public selectedDealer: DealeInfo | undefined;
  public klantNo: string = "";
  public isEdit: boolean = false;

  public systemTypes = ["SC800", "SC810", "SC850", "SC860", "SC900", "SC950", "SCX1000", "SCX2000", "SCX3000", "SCX4000"];
  public memoryTypes = ["8K Eprom", "32K Eprom"];


  public kopInfo: KopInfo = {
    klantNo: "",
    VOORNAAM: "",
    ACHTERNAAM: "",
    P_ADRES: "",
    P_PLAATS: "",
    P_POSTCODE: "",
    P_LAND: "",
    B_ADRES: "",
    B_PLAATS: "",
    B_POSTCODE: "",
    TELEFOON: "",
    FAX: "",
    EMAIL1: "",
    DIVERSEN: "",
    TYP_COMPUT: this.systemTypes[0],
    TYP_HOOFDB: this.memoryTypes[0],
  };

  ngOnInit() {
    if (!this.isEdit) {
      this.getDealers();
    }
  }

  async getDealers() {
    let q = await this.apiService.client.klanten.getRWDealers.query();

    this.dealers = q;
    this.filteredDealers = q;
    if (this.dealers.length > 0) {
      this.dealerChanged(this.dealers[0]);
    }
  }


  async dealerChanged(e: DealeInfo) {
    this.selectedDealer = e;
    this.klantNo = await this.apiService.client.klanten.getNextKlantZNo.query(e.INDEX);
  }
  handleDealerFilter(v: any) {
    this.filteredDealers = this.dealers.filter(d => d.NAAM.toLowerCase().indexOf(v.toLowerCase()) != -1);
  }
  onClose() {
    this.dialog.close();
  }

  onCancelAction() {

  }

  async onConfirmAction() {
    console.log(this.kopInfo);
    this.kopInfo!.klantNo = this.klantNo;
    if (this.isEdit) {
      await this.apiService.client.klanten.updateKlantInfo.mutate(this.kopInfo!);
      this.dialog.close();
    } else {
      await this.apiService.client.klanten.newKop.mutate({
        dealerIdx: this.selectedDealer!.INDEX,
        kopInfo: this.kopInfo
      });
      this.router.navigate([`/NEW/${this.klantNo}`]);

    }
  }
}
